import { request } from './request';

// 时间段接口
export interface TimeSlot {
  date: string;
  startTime: string;
  endTime: string;
  overtime: boolean;
  week: string;
}

// 面试信息响应接口
export interface InterviewProcessResponse {
  id: number;
  canConfirm: boolean;
  interviewId: number;
  stepId: number;
  name: string;
  enterpriseName: string;
  orderIndex: number;
  type: number;
  tplId: number;
  interviewerId: number;
  interviewType: number;
  interviewDuration: number;
  interviewStart: string;
  candidateName: string;
  interviewEnd: string;
  interviewUrl: string;
  interviewLocation: string;
  interviewRemark: string;
  rejectReson?: string;
  overtime: boolean;
  timeSlots: TimeSlot[];
  interviewSchedule: TimeSlot[];
  evaluatedAt: string;
  evaluatedResult: number;
  evaluatedComments: string;
  joinAt: string;
  status: number;
  flowStatus: number;
  createBy: number;
  createTime: string;
  updateTime: string;
  interviewSelected: {
    date: string;
    startTime: string;
    endTime: string;
    week: string;
  };
  date: string;
  startTime: string;
  endTime: string;
  week: string;
}

// 预约面试参数接口
export interface ScheduleInterviewParams {
  processId: number;
  date: string;
  time: string;
}

// 查询面试信息接口
export function getInterviewProcessApi(processId: string | number): Promise<InterviewProcessResponse> {
  return request({
    url: `/ats-interview/api/v1/interview/process/${processId}`,
    method: 'GET'
  });
}

// 预约面试接口
export function scheduleInterviewApi(params: ScheduleInterviewParams): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/select',
    method: 'POST',
    data: params
  });
}

// 拒绝面试参数接口
export interface RejectInterviewParams {
  processId: number;
  reason: string;
}

// 拒绝面试接口
export function rejectInterviewApi(params: RejectInterviewParams): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/reject',
    method: 'POST',
    data: params
  });
}

// 获取批量全部资料S3地址
export function getBatchAllDocumentsUrlApi(data: {
  interviewIds: (number | string)[]
}): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/interview/batch-download/all-documents/url',
    method: 'POST',
    data
  })
}

// 获取批量附件简历S3地址
export function getBatchAttachmentResumesUrlApi(data: {
  interviewIds: (number | string)[]
}): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/interview/batch-download/attachment-resumes/url',
    method: 'POST',
    data
  })
}

// 获取批量在线简历S3地址
export function getBatchOnlineResumesUrlApi(data: {
  interviewIds: (number | string)[]
}): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/interview/batch-download/online-resumes/url',
    method: 'POST',
    data
  })
}

// 获取附件简历S3地址
export function getInterviewResumeUrlApi(interviewId: number | string): Promise<any> {
  return request({
    url: `/ats-candidate/api/v1/interview/${interviewId}/resume/url`,
    method: 'GET'
  })
}

// 获取在线简历S3地址
export function getInterviewOnlineResumeUrlApi(interviewId: number | string): Promise<any> {
  return request({
    url: `/ats-candidate/api/v1/interview/${interviewId}/online-resume/url`,
    method: 'GET',
  })
}

// 获取全部资料S3地址
export function getInterviewAllDocumentsUrlApi(interviewId: number | string): Promise<any> {
  return request({
    url: `/ats-candidate/api/v1/interview/${interviewId}/all-documents/url`,
    method: 'GET'
  })
}

// 投递前重复校验参数接口
export interface CheckDuplicateApplicationParams {
  candidateId: number
  jobId: number
}

// 投递前重复校验接口
export function checkDuplicateApplicationApi(
  params: CheckDuplicateApplicationParams
): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/check-duplicate-application',
    method: 'POST',
    data: params
  })
}

// 更新面试官参数接口
export interface UpdateInterviewerParams {
  interviewId: number
  stepId: number
  interviewerId: number
  interviewRemark: string
}

// 更新面试官接口
export function updateInterviewerApi(
  params: UpdateInterviewerParams
): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/interviewer',
    method: 'PUT',
    data: params
  })
}

